import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface CookieConsentProps {
  onAccept?: () => void;
}

const CookieConsent: React.FC<CookieConsentProps> = ({ onAccept }) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookiesAccepted");
    if (!accepted) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookiesAccepted", "true");
    setVisible(false);
    if (onAccept) onAccept();
  };

  if (!visible) return null;

  return (
    <div
      className="cookie-consent d-flex flex-column flex-md-row justify-content-between align-items-center px-4 py-3"
      role="alert"
      aria-live="polite"
      style={{
        position: "fixed",
        bottom: 0,
        width: "100%",
        backgroundColor: "#fff", // jasny pomarańczowy, półprzezroczysty
        color: "#4f4f4f", // ciemny szary dla kontrastu
        fontWeight: "700",
        fontSize: "1.1rem",
        boxShadow: "0 -4px 12px rgba(163, 163, 163, 0.28)",
        zIndex: 2000,
        borderTopLeftRadius: "8px",
        borderTopRightRadius: "8px",
      }}
    >
      <span style={{ fontFamily: "'Yeseva One', cursive", marginBottom: "8px", textAlign: "center", flex: 1 }}>
        {t("cookieMessage")}
      </span>
      <button
        onClick={handleAccept}
        className="btn"
        style={{
          backgroundColor: "#F58220", // mocny pomarańczowy
          color: "white", // kontrastowy tekst na przycisku
          fontWeight: "700",
          borderRadius: "5px",
          padding: "8px 20px",
          border: "none",
          cursor: "pointer",
          flexShrink: 0,
        }}
      >
        {t("cookieAccept")}
      </button>
    </div>
  );
};

export default CookieConsent;
